// UTILS
import {searchAndReplace} from 'commons/js/utils/strings';

// CONSTANTS
const DECIMAL_VALUE_FOR_KILO = 1000;

/**
 * Gets a string in the format xx.xx and returns
 * a string in the format xx,xx.
 *
 * @param {string} value - The original value.
 * @param {string} [suffix] - The suffix to be used when desired.
 * @returns {string} - The final value.
 */
function formatUnit(value, suffix = '') {
  const formattedValue = searchAndReplace(value, '.', ',');

  if (suffix) {
    return `${formattedValue} ${suffix}`;
  }

  return formattedValue;
}

/**
 * Receives a string in the format xx,xx [suffix?] and returns
 * a number in the format xx.xx.
 *
 * @param {string} value - The original value.
 * @returns {number} - The raw value.
 */
function unformatUnit(value) {
  const [originalValue] = String(value).split(' ');

  return parseFloat(searchAndReplace(originalValue, ',', '.'));
}

/**
 * Converts a value in kilograms to grams.
 *
 * @param {number} value - Value to be converted in kilograms
 * @returns {number} Value in grams
 */
function kilogramsToGrams(value) {
  const result = value * DECIMAL_VALUE_FOR_KILO;

  return Number(result.toFixed(2));
}

/**
 * Formats a given distance with the properly prefix.
 *
 * @param {number} distance - A given distance to be formatted.
 * @returns {string} - The properly formatted distance in meters or kilometers.
 */
function formatDistance(distance) {
  if (distance < DECIMAL_VALUE_FOR_KILO) {
    return formatUnit(Math.round(distance), 'm');
  }

  const result = formatUnit((distance / DECIMAL_VALUE_FOR_KILO).toFixed(1), 'km');

  return result;
}

export {
  formatUnit,
  unformatUnit,
  formatDistance,
  kilogramsToGrams
};
